import { render, staticRenderFns } from "./PartnerDetails.component.vue?vue&type=template&id=2d8bdd85&"
import script from "./PartnerDetails.component.vue?vue&type=script&lang=ts&"
export * from "./PartnerDetails.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports